import { createRoutine } from 'redux-saga-routines';

export const createUnsubscriptionCategory = createRoutine(
  'CREATE_UN_SUBSCRIPTION_CATEGORY'
);
export const updateUnsubscriptionCategory = createRoutine(
  'UPDATE_UN_SUBSCRIPTION_CATEGORY'
);
export const deleteUnsubscriptionCategory = createRoutine(
  'DELETE_UN_SUBSCRIPTION_CATEGORY'
);
export const fetchAllUnsubscriptionCategory = createRoutine(
  'FETCH_ALL_UN_SUBSCRIPTION_CATEGORY'
);
export const fetchUnsubscriptionListByCategoryId = createRoutine(
  'FETCH_UN_SUBSCRIPTIONS_BY_CATEGORY_ID'
);
export const setUnsubscriptionCategory = createRoutine(
  'FETCH_UN_SUBSCRIPTION_CATEGORY'
);
export const resetSelectedUnsubscriptionCategory = createRoutine(
  'RESET_SELECTED_UN_SUBSCRIPTION_CATEGORY'
);
